import React from 'react'

function MotivationalMinute(): React.ReactElement {
  return (
    <div>
      <h6>....</h6>
    </div>
  )
}

export default MotivationalMinute
